
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#2C2C2C] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-serif text-2xl text-[#F8F6F3] mb-4">
              Edward J. Dumke
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              A native of the San Francisco Bay Area, crafting compelling family
              sagas and stories rooted in the rich history of the City by the Bay.
            </p>
            <p className="text-xs text-gray-500">
              © 2025 Edward J. Dumke. All rights reserved.
            </p>
          </div>

          <div>
            <h4 className="text-sm tracking-widest text-[#F8F6F3] mb-6 uppercase">
              Quick Links
            </h4>
            <div className="space-y-3">
              <Link
                to="/"
                className="block text-gray-400 hover:text-[#C9A961] transition-colors text-sm"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-gray-400 hover:text-[#C9A961] transition-colors text-sm"
              >
                About
              </Link>
              <Link
                to="/books"
                className="block text-gray-400 hover:text-[#C9A961] transition-colors text-sm"
              >
                Books
              </Link>
              <Link
                to="/blog"
                className="block text-gray-400 hover:text-[#C9A961] transition-colors text-sm"
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className="block text-gray-400 hover:text-[#C9A961] transition-colors text-sm"
              >
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm tracking-widest text-[#F8F6F3] mb-6 uppercase">
              Latest Release
            </h4>
            <div className="flex items-start space-x-4">
              <img
                src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/85c5105b512ab525c6805a40d3f56727.jpeg"
                alt="Family Secrets: A San Francisco Saga"
                className="w-24 h-36 object-cover rounded shadow-lg"
              />
              <div>
                <h5 className="text-[#F8F6F3] font-medium mb-1">
                  Family Secrets
                </h5>
                <p className="text-[#C9A961] text-sm mb-3">Available Now</p>
                <a
                  href="https://www.amazon.com/Family-Secrets-San-Francisco-Saga/dp/196736172X"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-[#C9A961] hover:text-white transition-colors text-sm whitespace-nowrap"
                >
                  Buy on Amazon
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#C9A961]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500">
          <div className="flex space-x-4">
            <span className="hover:text-[#C9A961] transition-colors cursor-pointer">
              Privacy Policy
            </span>
            <span className="text-gray-600">|</span>
            <span className="hover:text-[#C9A961] transition-colors cursor-pointer">
              Terms
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
